module.exports = __webpack_public_path__ + "static/media/Quam-Icon-Printer.f7087c4d.svg";